// @flow
export function updateArrayIndexFp<T>(
  array: Array<T>,
  index: number,
  updater: (field: T) => T,
): Array<T> {
  // $FlowFixMe
  return Object.values({ ...array, [index]: updater(array[index]) });
}
